const OWNER_CAPABILITIES = [
    'business.manage',
    'business.settings.manage',
    'services.manage',
    'team.manage',
    'clients.view',
    'clients.manage',
    'appointments.view',
    'appointments.manage',
    'schedule.self.manage',
    'team.schedule.manage',
    'messages.view',
    'messages.manage',
    'reports.view',
    'alerts.manage',
    'loyalty.manage',
    'payments.manage',
    'bookings.manage',
];
const ADMIN_CAPABILITIES = [
    'business.settings.manage',
    'services.manage',
    'team.manage',
    'clients.view',
    'clients.manage',
    'appointments.view',
    'appointments.manage',
    'schedule.self.manage',
    'team.schedule.manage',
    'messages.view',
    'messages.manage',
    'reports.view',
    'alerts.manage',
    'loyalty.manage',
    'payments.manage',
    'bookings.manage',
];
const PROVIDER_CAPABILITIES = [
    'clients.view',
    'appointments.view',
    'appointments.manage',
    'schedule.self.manage',
    'bookings.manage',
];
const CUSTOMER_CAPABILITIES = ['bookings.manage'];
export const ROLE_CAPABILITIES = {
    owner: OWNER_CAPABILITIES,
    admin: ADMIN_CAPABILITIES,
    provider: PROVIDER_CAPABILITIES,
    customer: CUSTOMER_CAPABILITIES,
};
export function capabilitiesForRole(role) {
    return ROLE_CAPABILITIES[role] ?? [];
}
export function can(role, capability) {
    return capabilitiesForRole(role).includes(capability);
}
export function isActiveMembershipStatus(status) {
    return status === 'active' || status === 'approved';
}
export function canAccessRoleList(role, allowedRoles) {
    return allowedRoles.includes(role);
}
//# sourceMappingURL=permissions.js.map